function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  color: #ef4444;\n  font-size: 0.875rem;\n  margin-top: 0.25rem;\n  margin-bottom: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from 'react';
import styled from '@emotion/styled';
var StyledErrorMessage = styled.p(_templateObject());
export var ErrorMessage = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ React.createElement(StyledErrorMessage, {
        className: className
    }, children);
};
export default ErrorMessage;
